import React from "react";

const RangedNumberRadioCheckbox = ({
  id,
  name,
  onChange,
  checkedParam,
  max = 10,
  min = 0,
}) => {
  return (
    <div className="custom-checkbox small" id={id}>
      {Array.from({ length: min + max }).map((_, index) => {
        let value;
        if (index === min) {
          value = min.toString();
        } else if (index === min + max - 1) {
          value = `${max}+`;
        } else {
          value = `${index}-${index + 1}`;
        }
        return (
          <div key={`rangedNumRadioCheck${id}${index}`}>
            <input
              type="radio"
              id={`check_${name}${index + min}`}
              name={name}
              value={value}
              onChange={onChange}
              checked={checkedParam === value}
            />
            <label htmlFor={`check_${name}${index + min}`}>{value}</label>
          </div>
        );
      })}
    </div>
  );
};

export default RangedNumberRadioCheckbox;
